import React, { useState } from 'react'
import * as API from "../../framework/API/api"
import { ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from "../../framework/constant/constant";
import { useTranslation } from '../../locale/useTranslation';
import { utility } from '../../framework/utility/utilityProvider';
import { EditPageHeader } from '../../components/EditPageHeader';
import BossDialog from '../../components/BossDialog';
import ToastNotification from '../../components/ToastNotification';

const AmortizationRuleEditForm = (props) => {

    const lang = useTranslation();
    const blankDataItem = {
        ...props.item,
        Description: props?.item?.copy ? "Copy of " + props.item.Description : props.item.Description ?? "",
        RuleText: props?.item?.RuleText ?? "",
        Archive: props?.item?.Archive ?? false,
    }
    const [dataItem, setDataItem] = useState(blankDataItem);

    const onChange = (e) => {
        if (e.target.name === 'Archive') {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const isValid = () => {
        if (dataItem.Description == undefined || dataItem.Description == "") {
            ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: lang.please_enter_description_error_message });
            return false;
        }
        if (dataItem.RuleText == undefined || dataItem.RuleText == "") {
            ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: lang.please_enter_rule_text_message });
            return false;
        }
        const ruleValues = dataItem.RuleText.split(",").map(val => parseFloat(val.trim()));
        const total = ruleValues.reduce((sum, num) => sum + (isNaN(num) ? 0 : num), 0);

        if (total !== 100) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.invalid_rule_text_total_error_message });
            return false;
        }

        return true;
    }

    const handleSubmit = async () => {
        if (!isValid()) return;

        const saveData = {
            _id: dataItem?._id,
            SID: dataItem?.SID,
            Description: dataItem?.Description,
            RuleText: dataItem?.RuleText,
            Archive: dataItem?.Archive ?? false,
            checkDuplicate: true,
            query: [["Description", "=", dataItem?.Description]]
        }
        const res = await API.saveData(ENTITYNAME.AmortizationRule, saveData);
        if (res.success) {
            let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.AMORTIZATION_RULE, data: res.data, message: res.message };
            API.SaveLogs(logData);
            utility.deleteLocalStorageItem(ENTITYNAME.AmortizationRule);
            props.cancelEdit();
            props.refresh();
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }
    return (
        <>
            <BossDialog
                title={props.item.Description ?? lang.amortization_rule_dialog_header}
                onClose={props.cancelEdit}
                width={"600px"}>
                <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
                <div className='row mt-2'>
                    <div className='col-6'>
                        <label>{lang.description_label} *</label>
                        <input
                            name={"Description"}
                            type="text"
                            className="form-control form-control-sm"
                            onChange={onChange}
                            value={dataItem.Description}
                        />
                    </div>
                    <div className="col-6">
                        <label>{lang.rule_text_label} *</label>
                        <input
                            name="RuleText"
                            type="text"
                            className="form-control form-control-sm"
                            onChange={onChange}
                            value={dataItem.RuleText}
                        />
                        <p>{lang.note_label}: {lang.rule_text_instruction}</p>
                    </div>
                </div>
                <div className='row'>
                    <div className='col'>
                        <input
                            style={{ border: "1px solid grey" }}
                            name={"Archive"}
                            type='checkbox'
                            onChange={onChange}
                        />
                        <label className="ml-2">{lang.archive}</label>
                    </div>
                </div>
            </BossDialog >
        </>
    )
}

export default AmortizationRuleEditForm